export const getRemValueInPixels = (remValue: number): number =>
	remValue * parseFloat(getComputedStyle(document.documentElement).fontSize);
